export {
  TextHeadline as default,
  TextHeadline,
  TextHeadlinePageTitle,
  TextHeadlineSectionTitle,
  TextHeadlineSectionSubTitle,
  TextHeadlineCardTitle,
  TextHeadlineBodyTitle,
} from './TextHeadline';

export type {
  TextHeadlineProps,
  HeadingLevel,
  HeadlineVariant,
  HeadlineColor,
} from './TextHeadline';